<template>
  <div class="navigator">
    <div class="topbar-wrap">
      <div class="topbar">
        <div class="topbar-left">
          <!-- 项目选择器（非客户账号显示） -->
          <el-select 
            v-if="!isCustomer && projectList.length > 0"
            v-model="currentProjectId" 
            placeholder="选择项目" 
            clearable
            class="project-selector"
            @change="onProjectChange"
          >
            <el-option label="全部项目" :value="null" />
            <el-option 
              v-for="p in projectList" 
              :key="p.id" 
              :label="p.name" 
              :value="p.id" 
            />
          </el-select>
          <!-- 客户账号显示当前项目名称 -->
          <span v-if="isCustomer && currentProjectName" class="current-project-name">
            <i class="el-icon-folder-opened"></i> {{ currentProjectName }}
          </span>
        </div>
        <div class="topbar-right">
          <a v-if="isAdmin" class="top-action" href="javascript:void(0);" @click="gotoAdmin">管理后台</a>
          <el-dropdown trigger="click" @command="onUserMenu">
            <span class="avatar-dot"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="center">个人中心</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="editor-wrap">
      <div class="app-container">
        <div class="toolbar">
          <div class="toolbar-left">
            <el-button type="primary" icon="el-icon-plus" @click="createFormVisible = true">新建问卷</el-button>
            <!--<el-radio-group v-model="aiEnabled" size="small" class="ai-toggle">
              <el-radio-button :label="true">AI生成问卷</el-radio-button>
            </el-radio-group>-->
            <el-button v-if="!isCustomer" class="ghost" @click="onCreateFolder">新建文件夹</el-button>
          </div>
          <div class="toolbar-right">
            <el-input v-model="queryParams.name" class="search" placeholder="请输入项目名称搜索" prefix-icon="el-icon-search" @keyup.enter.native="queryProjectPage" />
            <el-select v-model="filter.status" class="filter" placeholder="发布状态" @change="onFilterChange">
              <el-option v-for="(o, i) in statusOptions" :key="'status-'+i" :label="o.label" :value="o.value" />
            </el-select>
            <el-select v-model="filter.type" class="filter" placeholder="选择类型" @change="onFilterChange">
              <el-option v-for="(o, i) in typeOptions" :key="'type-'+i" :label="o.label" :value="o.value" />
            </el-select>
            <el-button circle icon="el-icon-menu" class="icon-btn" @click="onSwitchView"></el-button>
            <el-button circle icon="el-icon-more" class="icon-btn"></el-button>
          </div>
        </div>
        <div class="content">
          <div class="section-title">
            {{ isCustomer ? '项目问卷' : '我的项目' }}
            <span v-if="currentProjectId" class="project-filter-hint">
              （已筛选：{{ currentProjectName }}）
            </span>
          </div>
          <form-card-list v-if="dataShowType == 'card'" v-loading="projectListLoading" :project-list.sync="projectListView" @refresh="queryProjectPage" />
          <my-form-table v-if="dataShowType == 'table'" v-loading="projectListLoading" :project-list.sync="projectListView" @refresh="queryProjectPage" />
          <div class="project-page-view">
            <el-pagination v-if="total > queryParams.size" :current-page.sync="queryParams.current" :page-size.sync="queryParams.size" :total="total" background layout="total, prev, pager, next" @current-change="queryProjectPage" />
          </div>
        </div>
        <el-dialog class="create-form-dialog" :visible.sync="createFormVisible" :modal="true" :append-to-body="true" title="创建问卷" width="60%">
          <create-form ref="createForm" @select="handleTypeSelect" @operation="handleImportOp" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { signOut } from 'index/api'
import { createFormRequest, pageFormRequest } from 'index/api/project/form'
import { getProjectList } from 'index/api/project/manager'
import FormCardList from './card'
import CreateForm from './CreateForm'
import MyFormTable from './table'
export default {
  name: 'navigator',
  components:{ FormCardList, CreateForm, MyFormTable },
  data () {
    return {
      isSOI: !!process.env.VUE_APP_SOI,
      createFormVisible: false,
      dataShowType: 'card',
      total: 0,
      aiEnabled: false,
      filter: { status: null, type: 'all' },
      statusOptions: [
        { label: '已发布', value: 2 },
        { label: '未发布', value: 1 }
      ],
      typeOptions: [
        { label: '全部', value: 'all' },
        { label: '问卷调查', value: 1 },
        { label: '收集表单', value: 2 },
        { label: '考试测评', value: 3 },
        { label: '评估问卷', value: 4 },
        { label: '360评估', value: 5 }
      ],
      queryParams: { page:1, size:12, name:'', beginDateTime:null, endDateTime:null, status:null, folderId:0, current:1, projectId: null },
      formData: { description:'', name:'未命名问卷', type:0 },
      projectList: [],
      projectListView: [],
      projectListLoading: true,
      requestLoading: { pushFormData:false, pushFolderData:false },
      // 项目管理相关
      currentProjectId: null,
      currentProjectName: '',
      allProjects: [] // 所有可选项目列表
    }
  },

  computed: {
    userInfo () { return (this.$store && this.$store.getters && this.$store.getters.userInfo) || {} },
    safeUserName(){ const u = this.userInfo || {}; return u.name || u.username || '' },
    // 是否为管理员（用户名为admin）
    isAdmin() {
      const u = this.userInfo || {}
      return u.username === 'admin' || u.name === 'admin'
    },
    // 是否为客户账号
    isCustomer() {
      return this.$store && this.$store.getters && this.$store.getters.isCustomer
    },
    // 客户关联的项目ID
    customerProjectId() {
      return this.$store && this.$store.getters && this.$store.getters.customerProjectId
    }
  },

  created(){ 
    this.initProjectContext()
    this.loadProjectOptions()
    this.queryProjectPage() 
  },

  methods: {
    // 初始化项目上下文
    initProjectContext() {
      // 从URL参数获取项目ID
      const urlProjectId = this.$route.query.projectId
      if (urlProjectId) {
        this.currentProjectId = parseInt(urlProjectId)
        this.queryParams.projectId = this.currentProjectId
      }
      // 客户账号强制使用关联的项目ID
      if (this.isCustomer && this.customerProjectId) {
        this.currentProjectId = this.customerProjectId
        this.queryParams.projectId = this.customerProjectId
      }
    },
    // 加载项目选项列表
    async loadProjectOptions() {
      try {
        const res = await getProjectList({ page: 1, pageSize: 100 })
        this.allProjects = res.data.items || []
        // 设置当前项目名称
        if (this.currentProjectId) {
          const project = this.allProjects.find(p => p.id === this.currentProjectId)
          if (project) {
            this.currentProjectName = project.name
          }
        }
      } catch (e) {
        console.error('加载项目列表失败:', e)
      }
    },
    // 项目切换
    onProjectChange(projectId) {
      this.currentProjectId = projectId
      this.queryParams.projectId = projectId
      // 更新项目名称
      if (projectId) {
        const project = this.allProjects.find(p => p.id === projectId)
        this.currentProjectName = project ? project.name : ''
      } else {
        this.currentProjectName = ''
      }
      // 重新查询问卷列表
      this.queryProjectPage()
    },
    logout (event) {
      event.preventDefault()
      signOut().then(() => {
        localStorage.clear()
        window.location.href = '/'
      }).finally(() => {
        localStorage.clear()
        window.location.href = '/'
      })
    },
    gotoAdmin(){ window.location.href = '/admin' },
    onUserMenu(cmd){
      if(cmd==='admin') return this.gotoAdmin()
      if(cmd==='center') return window.location.href = '/admin/usercenter/userinfo'
      if(cmd==='logout') return this.logout({ preventDefault: ()=>{} })
    },
    onCreateFolder() { this.$message.success('已创建文件夹') },
    onSwitchView() { this.dataShowType = this.dataShowType === 'card' ? 'table' : 'card' },
    onFilterChange() { this.applyLocalFilter() },
    handleTypeSelect(payload) {
      const type = payload && payload.type
      const title = (payload && payload.title) ? payload.title : '未命名项目'
      const desc = (payload && payload.desc) ? payload.desc : ''
      this.requestLoading.pushFormData = true
      // 同时传递 type 和 formType 以兼容后端不同字段名
      const formType = type || 1
      const body = { 
        title, 
        desc, 
        type: formType,
        formType: formType, // 驼峰格式
        form_type: formType, // 下划线格式，匹配数据库字段名
        folderId: this.queryParams.folderId || 0,
        projectId: this.currentProjectId || this.$route.query.projectId || null
      }
      this.createFormVisible = false
      createFormRequest(body)
        .then(() => { this.queryProjectPage(); this.requestLoading.pushFormData = false })
        .catch(() => { this.requestLoading.pushFormData = false })
    },
    handleImportOp(op) { this.$message.info(op) },
    queryProjectPage() {
      // 客户账号强制使用关联的项目ID
      if (this.isCustomer && this.customerProjectId) {
        this.queryParams.projectId = this.customerProjectId
      }
      pageFormRequest(this.queryParams).then((res) => {
        let { records, total, size } = res.data.data
        this.projectList = records
        this.applyLocalFilter()
        this.total = total
        this.queryParams.size = size
        this.projectListLoading = false
      })
    },
    applyLocalFilter() {
      let list = this.projectList.slice()
      if (this.filter.status !== null) list = list.filter((p) => String(p.status) === String(this.filter.status))
      if (this.filter.type !== 'all') list = list.filter((p) => String(p.type) === String(this.filter.type))
      if (this.queryParams.name) { const kw = this.queryParams.name.toLowerCase(); list = list.filter((p) => (p.textName || p.name || '').toLowerCase().includes(kw)) }
      this.projectListView = list
    }
  }
}
</script>

<style lang="scss" scoped>
  .topbar-wrap{ padding:0; background:#f5f7fb; }
  .topbar{ display:flex; align-items:center; justify-content:space-between; background:#fff; height:60px; padding:0 24px; box-shadow:0 22px 44px rgba(0,0,0,0.16); border-radius:0; width:100%; margin:0; color:#303133; transition:box-shadow .2s ease; will-change: box-shadow; }
  .topbar:hover{ box-shadow:0 30px 60px rgba(0,0,0,0.26); }
  .topbar-left{ display:flex; align-items:center; gap:12px; }
  .topbar-right{ display:flex; align-items:center; gap:12px; }
  .top-item{ padding:8px 14px; border-radius:12px; color:#606266; }
  .top-item.primary{ background:#5c6cff; color:#fff; box-shadow:0 12px 28px rgba(92,108,255,0.55); }
  .top-item:hover{ background:#f5f7fb; }
  .top-action{ display:inline-block; padding:8px 16px; background:#4c5cff; color:#fff; border:none; border-radius:999px; box-shadow:0 10px 24px rgba(76,92,255,0.38); }
  .top-action:hover{ background:#3f4ee8; box-shadow:0 14px 32px rgba(76,92,255,0.48); }
  .top-user{ color:#606266; }
  .top-logout{ color:#409EFF; }
  .avatar-dot{ display:inline-block; width:30px; height:30px; border-radius:50%; background:#b3863a; box-shadow:0 4px 10px rgba(0,0,0,0.12); cursor:pointer; }

  /* 项目选择器样式 */
  .project-selector { width: 200px; }
  .current-project-name { 
    display: flex; 
    align-items: center; 
    gap: 6px; 
    font-size: 14px; 
    color: #409EFF; 
    font-weight: 500;
    i { font-size: 16px; }
  }
  .project-filter-hint {
    font-size: 12px;
    color: #909399;
    font-weight: normal;
  }

  .editor-wrap{ margin:12px 0 0 0; background:#fff; border-radius:0; box-shadow:0 16px 36px rgba(0,0,0,0.12); padding:16px 24px; width:100%; }
  .create-form-dialog { border-radius: 10px !important; }
  ::v-deep .create-form-dialog .el-dialog__body { padding: 0 !important; color: inherit; font-size: 14px; word-break: break-all; }
  .app-container { width: 100%; height: 100%; }
  .toolbar { display: flex; align-items: center; justify-content: space-between; background: #fff; padding: 12px; border-radius: 12px; }
  .toolbar-left { display: flex; align-items: center; gap: 12px; }
  .toolbar-right { display: flex; align-items: center; gap: 12px; }
  .ai-toggle .el-radio-button__inner { padding: 6px 12px; }
  .ghost { border: 1px solid #e5e7eb; }
  .search { width: 320px; }
  .filter { width: 140px; }
  .icon-btn { border: none; }
  .content { margin-top: 12px; }
  .section-title { font-size: 16px; color: #303133; margin-bottom: 12px; }
  .project-page-view { margin-top: 16px; text-align: center; }
</style>
